import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from '@/context/modalContext';

export const ModalProvider = ({ children }) => {
  const [modalName, setModalName] = useState('');

  const closeModal = () => setModalName('');
  const memoizedModalContext = useMemo(
    () => ({
      closeModal,
      modalName,
      setModalName,
    }),
    [modalName, setModalName]
  );

  return (
    <ModalContext.Provider value={memoizedModalContext}>
      {children}
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
